import createUseStyles from '@picsart/rc/create';
import { BorderRadiuses } from '@picsart/rc/enums';
import { FontWeights } from '@picsart/rc/fonts';
import { isLeftToRight } from '@picsart/rc/helpers';

const useSearchFormLargeStyles = createUseStyles(
  {
    root: {},
    form: {
      position: 'relative',
      maxWidth: '500px',
    },
    searchInput: {
      backgroundColor: 'var(--backgrounds-tint-1)',
      borderRadius: BorderRadiuses.Size_4,
      borderColor: 'transparent',
      width: '100%',
      padding: '0 60px 0 16px',
      height: 40,
      border: '1px solid var(--backgrounds-tint-2)',

      '&::placeholder': {
        opacity: 0.5,
        fontWeight: FontWeights.Medium,
      },
    },
    searchButton: {
      display: 'inline-block',
      height: '100%',
      padding: '0 15px',
      position: 'absolute',
      top: 0,
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none',
      color: 'var(--texts-negative)',
      cursor: 'pointer',

      [isLeftToRight()]: {
        right: 0,
      },
      [isLeftToRight(false)]: {
        left: 0,
      },
    },
    searchIcon: {
      display: 'block',
      width: 28,
      height: 28,
    },
  },
  { name: 'search-form-large' },
);

export default useSearchFormLargeStyles;
